import { useEffect, useMemo, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { useSatSteps } from "../../../hooks";
import { useAppDispatch, useAppSelector } from "../../../store";
import { getAsync } from "../../../store/clientQuestionnaires";
import Welcome from "../../savingsAdviceTool/Welcome";
import AssetAllocationOptions from "./steps/AssetAllocationOptions";
import BeginQuestions from "./steps/BeginQuestions";
import ContributionCalculator from "./steps/ContributionCalculator";
import KiwiSaverCalculator from "./steps/KiwiSaverCalculator";
import LearnMore from "./steps/LearnMore";
import LifeCycle from "./steps/LifeCycle";
import SelfSelect from "./steps/SelfSelect";
import Summary from "./steps/Summary";
import Thanks from "./steps/Thanks";
import WealthBuilder from "./steps/WealthBuilder";
import WeAreNzFunds from "./steps/WeAreNzFunds";

export default ({ match }: RouteComponentProps) => {
  const { isLoading, responses } = useAppSelector((state) => state.clientQuestionnaires);
  const dispatch = useAppDispatch();
  const path = useMemo(() => match.path, [match.path]);
  const clientId = useMemo(() => (match.params as { clientId: string }).clientId, [match.params]);
  const { goToInitialStep } = useSatSteps();
  const [initialised, setInitialised] = useState(false);

  useEffect(() => {
    if (!responses && !isLoading) {
      dispatch(getAsync(clientId));
    }
  }, [clientId, dispatch, isLoading, responses]);

  useEffect(() => {
    if (!initialised && responses) {
      setInitialised(true);
      goToInitialStep();
    }
  }, [goToInitialStep, initialised, responses]);

  return (
    <Switch>
      <Route path={`${path}/welcome`} exact render={(routeProps) => <Welcome {...routeProps} isClient />} />
      <Route path={`${path}/we-are-nz-funds`} exact render={(_) => <WeAreNzFunds />} />
      <Route path={`${path}/learn-more`} exact render={(_) => <LearnMore />} />
      <Route path={`${path}/begin-questions`} exact render={(_) => <BeginQuestions />} />
      <Route path={`${path}/ks-life-cycle`} exact render={(_) => <LifeCycle />} />
      <Route path={`${path}/ks-self-select`} exact render={(_) => <SelfSelect />} />
      <Route path={`${path}/wb-life-cycle`} exact render={(_) => <LifeCycle />} />
      <Route path={`${path}/wb-self-select`} exact render={(_) => <SelfSelect />} />
      <Route path={`${path}/ks-asset-allocation-options`} exact render={(_) => <AssetAllocationOptions />} />
      <Route path={`${path}/wb-asset-allocation-options`} exact render={(_) => <AssetAllocationOptions />} />
      <Route path={`${path}/kiwisaver-calculator`} exact render={(_) => <KiwiSaverCalculator />} />
      <Route path={`${path}/wealth-builder`} exact render={(_) => <WealthBuilder />} />
      <Route path={`${path}/contribution-calculator`} exact render={(_) => <ContributionCalculator />} />
      <Route path={`${path}/summary`} exact render={(routeProps) => <Summary {...routeProps} />} />
      <Route path={`${path}/thanks`} exact render={(routeProps) => <Thanks {...routeProps} />} />
    </Switch>
  );
};
